import { render, staticRenderFns } from "./SeasonalChristmas.vue?vue&type=template&id=1283b628&scoped=true"
import script from "./SeasonalChristmas.vue?vue&type=script&lang=ts"
export * from "./SeasonalChristmas.vue?vue&type=script&lang=ts"
import style0 from "./SeasonalChristmas.vue?vue&type=style&index=0&id=1283b628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283b628",
  null
  
)

export default component.exports